
export const theme = {
  palette: {
    primary: '#A2D146',
    lightBlue: '#45BABA',
    darkBlue: '#2D6CB5',
    orange: '#F49700',
    gray: '#393939'
  }
}